import { render, staticRenderFns } from "./CardRestaurant.vue?vue&type=template&id=7010ea0c&scoped=true&"
import script from "./CardRestaurant.vue?vue&type=script&lang=js&"
export * from "./CardRestaurant.vue?vue&type=script&lang=js&"
import style0 from "./CardRestaurant.vue?vue&type=style&index=0&id=7010ea0c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7010ea0c",
  null
  
)

export default component.exports